import { render } from "./Beanie_12_back.vue?vue&type=template&id=a5a047aa"
import script from "./Beanie_12_back.vue?vue&type=script&lang=js"
export * from "./Beanie_12_back.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend-staging/apps/dyo-frontend-staging/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__